import { useState } from "react"
import { colors } from "../constant/color"

interface ColorDropdownInputProps {
    color_idx: number
    onSelect: (color: number) => void
}

const ColorDropdownInput: React.FC<ColorDropdownInputProps> = ({
    onSelect, color_idx
}) => {

    const [open, setOpen] = useState(false)


    return <>
        <div className="relative text-sm">
            <div className="p-2 flex justify-between items-center justify-center border border-gray-nor rounded">
                <div className="flex gap-3">
                    <div className={`w-5 h-5 ${colors[color_idx][1]}`}></div>
                    <p className="text-black">{colors[color_idx][0]}</p>
                </div>
                
                <img src="./down-arrow.svg" alt="" className="w-3 cursor-pointer" onClick={() => setOpen(!open)}/>
            </div>
            { open && <div className="absolute z-10 w-full overflow-y-auto h-36 shadow-lg rounded">
                { colors.map((opt, idx) => {
                    return <div className="bg-white w-full p-2 text-gray-nor border-b flex gap-3 cursor-pointer"
                    onClick={() => {
                        onSelect(idx)
                        setOpen(!open)
                    }}>
                        <div className={`w-5 h-5 ${opt[1]}`}></div>
                        <p className="text-black">{opt[0]}</p>
                    </div>
                }) }
            </div>}
        </div>
    </>
}

export default ColorDropdownInput